import { createTheme } from '@atlaskit/theme/components';

/**
 * Creates the default theme, which can be customised using the `theme` prop
 *
 * @deprecated
 */
export var Theme = createTheme(function (props) {
  return {
    container: {},
    bar: {},
    determinateBar: {},
    increasingBar: {},
    decreasingBar: {}
  };
});